import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from '@phosphor-icons/react';
import { Oval } from 'react-loader-spinner';
import { saveAs } from 'file-saver';
import { useTheme } from '../../providers/theme';
import { LoadingContext } from '../../providers/loading';
import { TextComponent } from '../TextComponent';
import { Button } from '../Button';
import { Project } from '../../types/ProjectType';
import { BoxTextModal, Checkbox, CheckboxContainer, ContentModal, DateInput, Footer, HeaderModal, InputContainer, ModalContainer } from './style';
import { InputComponent } from '../InputComponent';
import { UserDataContext } from '../../providers/userData';
import axios from 'axios';

type DownloadCsvProps = {
  project: Project;
  isOpen: boolean;
  toggle: () => void;
}

export function DownloadCsvModal({ project, isOpen, toggle }: DownloadCsvProps) {
  const date = new Date();
  const [ dateFormated ] = date.toISOString().split('T');

  const { userData } = useContext(UserDataContext);
  const { isLoading, setIsLoading } = useContext(LoadingContext);

  const [startDate, setStartDate] = useState('2001-01-01');
  const [finalDate, setFinalDate] = useState(dateFormated);
  const [filterByOwnerId, setFilterByOwnerId] = useState(false);
  const [ownerIdFilter, setOwnerIdFilter] = useState(userData.userEmail);

  const { t } = useTranslation();
  const { theme } = useTheme();
  const { id, title } = project;

  async function fetchCsvFile() {
    setIsLoading({ value: true });

    try {
      if(filterByOwnerId) {
        await axios.get(`https://r62dhl55ej.execute-api.sa-east-1.amazonaws.com/production/file?id=${id}&name=${title}&start_date=${startDate}&end_date=${finalDate}&owner_id=${ownerIdFilter}`, {
          responseType: 'blob'
        })
          .then((response) => {
            if (response?.status === 200) {
              const blob = new Blob([response.data], { type: 'text/csv' });
              const fileName = `'${title}-${date.toISOString()}'.csv`;
              saveAs(blob, fileName);
            }
            setIsLoading({ value: false });
          });
        return;
      }

      await axios.get(`https://r62dhl55ej.execute-api.sa-east-1.amazonaws.com/development/file?id=${id}&name=${title}&start_date=${startDate}&end_date=${finalDate}`, {
        responseType: 'blob'
      })
        .then((response) => {
          if (response?.status === 200) {
            const blob = new Blob([response.data], { type: 'text/csv' });
            const fileName = `${title}-${date.toISOString()}.csv`;
            saveAs(blob, fileName);
          }
          setIsLoading({ value: false });
        });
    } catch (error) {
      console.log(error);
    }
  }

  return(
    <>
      {isOpen && (
        <ModalContainer>
          <BoxTextModal>
            <HeaderModal>
              <span style={{ flexGrow: 1, textAlign: 'center' }}>{t('group-table-action-download').toUpperCase()}</span>
              <X onClick={toggle} size={25} color={theme.colors.red} weight='bold' cursor='pointer' />
            </HeaderModal>

            <ContentModal>
              <InputContainer>
                <TextComponent
                  fontWeight='bold'
                  fontSize='14px'
                >
                  {t('initial-date')}
                </TextComponent>
                <DateInput
                  aria-label='Date'
                  type='date'
                  value={startDate}
                  onChange={(event) => setStartDate(event.target.value)}
                />
              </InputContainer>

              <InputContainer>
                <TextComponent
                  fontWeight='bold'
                  fontSize='14px'
                >
                  {t('final-date')}
                </TextComponent>
                <DateInput
                  aria-label='Date'
                  type='date'
                  value={finalDate}
                  onChange={(event) => setFinalDate(event.target.value)}
                />
              </InputContainer>

              <InputContainer>
                <CheckboxContainer>
                  <Checkbox type='checkbox' onClick={() => setFilterByOwnerId(!filterByOwnerId)} />
                  <TextComponent
                    fontWeight='bold'
                    fontSize='14px'
                  >
                    {'Filtrar por Usuário'}
                  </TextComponent>
                </CheckboxContainer>
              </InputContainer>

              {filterByOwnerId && (
                <InputContainer>
                  <TextComponent
                    fontWeight='bold'
                    fontSize='14px'
                  >
                    {'Usuário'}
                  </TextComponent>
                  <InputComponent
                    id='ownerIdFilter'
                    type='text'
                    value={ownerIdFilter}
                    onChange={(event) => setOwnerIdFilter(event.target.value)}
                    placeholder={'ex: nome@email.com'}
                  />
                </InputContainer>
              )}

              <Footer>
                <Button
                  id='save'
                  type='submit'
                  color={theme.colors.main}
                  sxhover={theme.colors.hoverMain}
                  sxmargintop='20px'
                  onClick={fetchCsvFile}
                >
                  {isLoading.value ? (
                    <Oval color='#fff' secondaryColor='#fff' height='20px' />
                  ) : t('generate-csv').toUpperCase()}
                </Button>
              </Footer>
            </ContentModal>
          </BoxTextModal>
        </ModalContainer>
      )}
    </>
  );
}
